'use strict'
/**
 * External Dependencies
 */
import 'jquery'
import 'bootstrap'
import 'slick-slider/slick/slick'
import 'magnific-popup/dist/jquery.magnific-popup'
import 'select2'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

import {
  splitTextIntoChunks,
  setUpTextAnimation,
} from './utilities/text_animation'

import { isIE } from './utilities/isIE'



if(isIE()) {
  $('#no-IE-support').removeClass('d-none')
} else {


  jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ){
      if ( ns.includes("noPreventDefault") ) {
        this.addEventListener("touchstart", handle, { passive: false });
      } else {
        this.addEventListener("touchstart", handle, { passive: true });
      }
    }
  };
  jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ){
      if ( ns.includes("noPreventDefault") ) {
        this.addEventListener("touchmove", handle, { passive: false });
      } else {
        this.addEventListener("touchmove", handle, { passive: true });
      }
    }
  };

  require('./utilities/screen_setup')
  require('./utilities/page_header')
  require('./utilities/sidebar_navigation')

  require('./blocks/hero-header')
  require('./blocks/front-video')
  require('./blocks/quotes-slider')
  require('./blocks/video-slider')
  require('./blocks/learning-cycle')
  require('./blocks/drone-slider')
  require('./blocks/parallax-image')
  require('./blocks/scroll-quotes')
  require('./blocks/extra-modules')
  require('./blocks/apply-for-courses-with-contract')


  require('./popup/contact-form')
  require('./popup/exam-form')
  require('./components/content-tabs')

  require('./home')


  /* Preloader */
  let preloaderMaxDashoffset = 322
  let preloaderDashoffset = 322
  let preloader = $('#preloader-circle circle')
  let preloaderPercent = '322%'
  let percentLoaded = 0
  let showPercent = 1
  let animateFinish = 20 //for transition animation to finish

  function animatePreloader () {
    let reloadeAnim = requestAnimationFrame(animatePreloader)
    let precentProgress = parseInt($('.pace-progress').attr('data-progress'))
    percentLoaded = (parseInt(precentProgress) + parseInt(1)) / 100
    showPercent = 1 - percentLoaded

    if (precentProgress <= 99) {
      preloaderDashoffset = preloaderMaxDashoffset * showPercent
      preloaderPercent = preloaderDashoffset + '%'
      preloader.attr('stroke-dashoffset', preloaderPercent)

      if (precentProgress === 99) {

        animateFinish -= 1
        if (animateFinish <= 0) {
          cancelAnimationFrame(reloadeAnim)

          $('#preloader').addClass('loaded')
          $('.block-video-slider video').hide()
        }
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function (event) {

    splitTextIntoChunks()
    setUpTextAnimation()

    if($('.page-index').length) {
      setTimeout(function () {
        animatePreloader()
      }, 500)
    } else {
      $('#preloader').addClass('loaded')
      $('.block-video-slider video').hide()
    }

  })

  $(window).on('load', function (){
    $('.page-header').removeClass('d-none')
  })

}


